<template>
  <div class="fixed bottom-0 left-0 w-full h-[52px] md:h-[72px] shadow-footer">
      <div class="container h-full">
        <div class="flex items-center h-full my-auto">
          <div class="flex items-center justify-between w-full gap-8">
            <button @click="toDashboard"
              class="flex items-center font-semibold transition duration-300 hover:text-brand-indigo"
              type="submit">
              <svg class='mr-1 icon icon-chevron-left'><use xlink:href='#icon-chevron-left'></use></svg>
              Back to Dashboard
            </button>

            <div class="flex-1 bg-brand-cloud rounded-full h-2.5" v-if="status !== 'publish'">
              <div
                class="bg-brand-indigo h-2.5 rounded-full"
                :style="{ width: progress + '%' }"
              ></div>
            </div>

            <div class="flex items-center gap-4">
              <input @click="triggerSave" type="button"
                class="flex items-center mt-0 btn-secondary" :value="saveText" v-if="status !== 'publish'"/>

              <button @click="toStyle"
                class="flex items-center mt-0 btn-primary"
                v-if="status !== 'publish' && page < totalPages" >Next</button>

              <button @click="toFinish"
                class="flex items-center mt-0 btn-primary"
                v-if="page === totalPages && status !== 'publish'">Finish</button>

              <button @click="triggerUpdateSave"
                class="flex items-center mt-0 btn-primary"
                v-if="status === 'publish'">Save Changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';

//Props
const props = defineProps({
  page: Number,
  saveText: String,
  totalPages: Number,
  status: String,
});

// Emit
const emit = defineEmits(['triggerSave', 'triggerToDashboard', 'triggerToNextPage', 'triggerUpdateSave']);

const triggerUpdateSave = async () => {
  emit('triggerUpdateSave', true);
}
// Methods
const triggerSave = async () => {
  emit('triggerSave', true);
};

const toStyle = async () => {
  emit('triggerToNextPage', true);
};

const toFinish = async () => {
  emit('triggerToDashboard', true);
};

const toDashboard = async () => {
  window.location.href = '/';
  // if(props.status === 'publish') {
  // } else {
  //   emit('triggerToDashboard', true);
  // }
};

const progress = computed(() => {
  // Page 1 (IntakeStyles) = 20%, Page 2 (IntakeWrapper) = 40%
  return (props.page / 5) * 100;
});
</script>
